<template>
	<div class="full">
		<vxe-table :data="tableData" height="90%" border :tooltip-config="{showAll:true}">
			<vxe-column type="seq" width="60"></vxe-column>
			<vxe-column field="name" title="文件名"></vxe-column>
			<vxe-column field="audit" title="是否审核" :formatter="isaudit"></vxe-column>
			<vxe-column title="操作" width="100" show-overflow align="center">
				<template #default="{ row }">
					<vxe-button status="primary" type="text" @click="download(row)">下载</vxe-button>
				</template>
			</vxe-column>
		</vxe-table>
		<file-index type="download" :comapnyid="comapnyid" :row="currentrow" ref="contractfile" />
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import fileIndex from '@/components/forms/contract/audit/index.vue'
	export default {
		name: 'onlineIndex',
		props: {
			row: {
				type: Object,
				default: () => {
					return {}
				}
			},
			list: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				allAlign: null,
				tableData: [],
				currentrow:null,
				comapnyid:0,
			}
		},
		watch: {
			// row(e){
			// 	if(e){
			// 		this.getonline()
			// 	}		
			// }
		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			isaudit({
				cellValue
			}) {
				return window.systemMethods.getEmunValue('enable', cellValue)
			},
			download(row){
				this.currentrow = row
				this.comapnyid = this.row.comapnyid
				this.$refs.contractfile.modalShow = true
			},
			getdetail() {
				this.$api.contract.getdetail(this.row.id).then((res) => {
					this.tableData = res
				})
			}
		},
		components: {
			fileIndex
		}
	}
</script>
